import { IUploader } from "./IUploader.js";
export const uploader = new IUploader({
  accept: "*",
  once: false,
  autoStart: true,
  params: {
    get enterpriseId() { return require('@/store/index').default.state.enterprise.enterpriseId; }
  },
  panel: () => import("./IPanel.vue"),
  showPanel: false,
  onAdd(file) {
    return !!file.size;
  }
});
